/**
 * Toggle library panel visibility
 */
export function toggleLibraryPanel(renderSampleLibrary: () => void | Promise<void>): void {
  const panel = document.getElementById('library-panel');
  if (panel) {
    const isVisible = panel.classList.contains('visible');
    panel.classList.toggle('visible', !isVisible);
    if (!isVisible) {
      const result = renderSampleLibrary();
      if (result instanceof Promise) {
        result.catch(err => console.error('Error rendering sample library:', err));
      }
    }
  }
}
